import { Controller } from "@hotwired/stimulus"

// Lease cash price must be >= 0.01
const MIN_NEW_RATE = 0.01

export default class extends Controller {
  static targets = ["percentageInput", "amountInput", "newRateInput"]
  static values = { oldRate: Number }

  connect() {
    if (this.newRateInputTarget.value) {
      this.handleChange({ target: this.newRateInputTarget })
    }
  }

  handleChange(e) {
    const { percentage, amount, newRate } = this.#calculateValues(e.target, parseFloat(e.target.value))
    this.#updateInputs(percentage, amount, newRate)
  }

  #calculateValues(source, value) {
    let percentage, amount, newRate

    if (isNaN(value)) {
      return { percentage, amount, newRate }
    }

    switch (source) {
      case this.percentageInputTarget:
        return this.#fromPercentage(value)
      case this.amountInputTarget:
        return this.#fromAmount(value)
      case this.newRateInputTarget:
        return this.#fromNewRate(value)
      default:
        return { percentage, amount, newRate }
    }
  }

  #fromAmount(amount) {
    const percentage = (amount / this.oldRateValue) * 100
    const newRate = this.oldRateValue + amount
    if (newRate < MIN_NEW_RATE) {
      return this.#fromNewRate(newRate)
    }
    return { percentage, amount, newRate }
  }

  #fromNewRate(newRate) {
    newRate = Math.max(newRate, MIN_NEW_RATE)
    const amount = newRate - this.oldRateValue
    const percentage = (amount / this.oldRateValue) * 100
    return { percentage, amount, newRate }
  }

  #fromPercentage(percentage) {
    const amount = this.oldRateValue * (percentage / 100)
    const newRate = this.oldRateValue + amount
    if (newRate < MIN_NEW_RATE) {
      return this.#fromNewRate(newRate)
    }
    return { percentage, amount, newRate }
  }

  #updateInputs(percentage, amount, newRate) {
    this.percentageInputTarget.value = percentage != null && isFinite(percentage) ? percentage.toFixed(2) : ""
    this.amountInputTarget.value = amount != null && isFinite(amount) ? amount.toFixed(2) : ""
    this.newRateInputTarget.value = newRate != null && isFinite(newRate) ? newRate.toFixed(2) : ""
  }
}
